import ControlValveControlPanel from "../components/ControlValveControlPanel";
import "../components/ControlValveControlPanel.css";
import Valve from "../components/Valve";
import "./NK1Wellhead.css";
import { useState, useEffect, useContext } from "react";
import { WellContext } from "../context/WellContext";
import Transmitter from "../components/Transmitter";
import { AlarmContext } from "../context/AlarmContext";

import { trackPageVisit } from "../competency/PageTracker";


console.log(window.innerWidth, window.innerHeight);

/* 🔥 TEMPERATURE TRANSMITTER */
function TemperatureTransmitterOutput({ value, x, y, unit }) {
  const temp = Number(value) || 0;

  let statusClass;

  if (temp < 49) {
    statusClass = "alarm";
  } else if (temp >= 50 && temp <= 99) {
    statusClass = "warning";
  } else if (temp >= 100 && temp <= 280) {
    statusClass = "normal";
  } else if (temp >= 281) {
    statusClass = "alarm";
  } else {
    statusClass = "normal"; // fallback safety
  }

  return (
    <div
      className={`temperature-transmitter-output ${statusClass}`}
      style={{ position: "absolute", left: x, top: y }}
    >
      {temp.toFixed(3)} {unit}
    </div>
  );
}

/* 🔥 PRESSURE TRANSMITTER */
function PressureTransmitterOutput({ value, x, y, unit }) {
  const pressure = Number(value) || 0;

  let statusClass;

  if (pressure < 10) {
    statusClass = "alarm";
  } else if (pressure >= 10 && pressure <= 19) {
    statusClass = "warning";
  } else if (pressure >= 20 && pressure <= 100) {
    statusClass = "normal";
  } else if (pressure >= 101 && pressure <= 149) {
    statusClass = "warning";
  } else if (pressure >= 150) {
    statusClass = "alarm";
  } else {
    statusClass = "normal"; // fallback safety
  }

  return (
    <div
      className={`pressure-transmitter-output ${statusClass}`}
      style={{ position: "absolute", left: x, top: y }}
    >
      {pressure.toFixed(3)} {unit}
    </div>
  );
}



/* ✅ Reusable Indicator */
function Indicator({ x, y, isClosed }) {
  return (
    <svg width="80" height="80" style={{ position: "absolute", left: x, top: y }}>
      <circle
        cx="40"
        cy="30"
        r="17"
        fill={isClosed ? "red" : "lime"}
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  );
}


      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
  function ValveOutput({ value, x, y }) {
  return (
    <div
      style={{
        position: "absolute",
        left: x,
        top: y,
        color: "white",
        fontSize: "10px",
        padding: "2px 6px",
        borderRadius: "4px"
      }}
    >
      {value.toFixed(1)}
    </div>
  );
}





/* ✅ Main Component */
function NK1Wellhead() {

        useEffect(() => {
  
    trackPageVisit("NK1Wellhead");
  
  }, []);

  const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("nk1_valveData");
  return saved
    ? JSON.parse(saved)
    : {
        FCV_10101: { mode: "Manual", opening: 0, sp: "", pv: "" },
        FCV_10102: { mode: "Manual", opening: 0, sp: "", pv: "" },
        FCV_10103: { mode: "Manual", opening: 0, sp: "", pv: "" },
        FCV_10104: { mode: "Manual", opening: 0, sp: "", pv: "" },
        FCV_10105: { mode: "Manual", opening: 0, sp: "", pv: "" },
        FCV_10106: { mode: "Manual", opening: 0, sp: "", pv: "" },
        CHK_101: { mode: "Manual", opening: 0, sp: "", pv: "" }
      };
    });

      
    
     const { valves, toggleValve } = useContext(WellContext);


    useEffect(() => {
      localStorage.setItem("nk1_valveData", JSON.stringify(valveData));
    }, [valveData]);

    
      const { getPT10103, getTT10101 } = useContext(WellContext);



        const [FIC_10808, setFIC_10808] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_10808")) || 0;
            setFIC_10808(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

        const [PT_10808, setPT_10808] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_10808")) || 0;
            setPT_10808(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);





        const isGLV1Open = valves.GLV_1 === false;
        const isGLV2Open = valves.GLV_2 === false;
        const isGLV3Open = valves.GLV_3 === false;
        const isGLV4Open = valves.GLV_4 === false;


            

                const isOpen = (tag) => !valves[tag]; // IMPORTANT: normalize logic             
                const xv10108Open = isOpen("XV_10108");

                const fcvOpening = Number(valveData.FCV_10102?.opening ?? 0);
                const fcvFactor = fcvOpening / 100;

                let fic10100 = 0;
                let pt10107 = 0;

                if (xv10108Open) {
                  fic10100 = fcvFactor * 12;
                  pt10107 = fcvFactor * 10;
                } else {
                  fic10100 = 0;
                  pt10107 = 0.003;
                }


                // ===============================
                // CONTROL: FCV-10103 → FIC-10102 & PT-10108
                // ===============================

                const fcv10103Opening = Number(valveData.FCV_10103?.opening ?? 0);
                const fcv10103Factor = fcv10103Opening / 100;

                // optional: if you want XV interlock (recommended for realism)
                const xv10101Open = isOpen("XV_10101");

                let fic10102 = 0;
                let pt10108 = 0;

                if (xv10101Open) {
                  // Flow through FCV-10203
                  fic10102 = fcv10103Factor * 15;   // <-- scaling factor (adjust as needed)
                  pt10108 = fcv10103Factor * 12;    // <-- pressure response
                } else {
                  fic10102 = 0;
                  pt10108 = 0.003; // shutdown leakage / dead pressure
                }


                  // ===============================
                // CONTROL: FCV-10101 → FIC-10101 & PT-101089
                // ===============================

                const fcv10101Opening = Number(valveData.FCV_10101?.opening ?? 0);
                const fcv10101Factor = fcv10101Opening / 100;

                // optional: if you want XV interlock (recommended for realism)
                const xv10109Open = isOpen("XV_10109");

                let fic10101 = 0;
                let pt10109 = 0;

                if (xv10109Open) {
                  // Flow through FCV-10203
                  fic10101 = fcv10101Factor * FIC_10808;   // <-- scaling factor (adjust as needed)
                  pt10109 = fcv10101Factor * PT_10808;    // <-- pressure response
                } else {
                  fic10101 = 0;
                  pt10109 = 0.003; // shutdown leakage / dead pressure
                }




                const FIC_101051 = isGLV1Open ? fic10101 * 0.05 : 0;
                const PT_101051 = isGLV1Open ? pt10109 * 0.05 : 0;

                
                const FIC_101052 = isGLV2Open ? fic10101 * 0.09 : 0;
                const PT_101052 = isGLV2Open ? pt10109 * 0.08 : 0;

                const FIC_101053 = isGLV3Open ? fic10101 * 0.11 : 0;
                const PT_101053 = isGLV3Open ? pt10109 * 0.11 : 0;

                const FIC_101054 = isGLV4Open ? fic10101 * 0.13 : 0;
                const PT_101054 = isGLV4Open ? pt10109 * 0.13 : 0;



      const tt10101Value = getTT10101("NK1");
      const pt10103Value = getPT10103("NK1");
      const pt10104Value = PT_101053 + PT_101054 + pt10103Value * 0.915;
      const pt101013Value = PT_101052 + pt10104Value * 0.386;

      
      const [tt10102Value, setTT10102Value] = useState(() => {
          return Number(localStorage.getItem("TT_10102")) || 0;
        });

        useEffect(() => {
          const interval = setInterval(() => {
            setTT10102Value(prev => {
              const target = tt10101Value * 0.88;
              const diff = target - prev;

              const step = diff * 0.05; // slower (thermal lag)

              if (Math.abs(diff) < 0.001) return target;

              return prev + step;
            });
          }, 200);

          return () => clearInterval(interval);
        }, [tt10101Value]);

        useEffect(() => {
          localStorage.setItem("TT_10102", tt10102Value);
        }, [tt10102Value]);






                  const xv10105Open = isOpen("XV_10105");

                let fic10109 = 0;
                let pt10101 = 0;

                if (xv10105Open) {
                  fic10109 = 15;   // <-- scaling factor (adjust as needed)
                  pt10101 = 12.67;    // <-- pressure response
                } else {
                  fic10109 = 0;
                  pt10101 = 0.003; // shutdown leakage / dead pressure
                }







      const tt10105Value = tt10102Value * 0.90;
      const pt10105Value = PT_101051 + pt101013Value * 0.73;

      const isSSSVClosed = valves.SSSV_10102;
      const isDHSVClosed = valves.DHSV_10101;
      const isWellShut = isSSSVClosed || isDHSVClosed;

      const chkOpening = Number(valveData.CHK_101?.opening) || 0;

      const chkFactor = chkOpening / 100;

      const pt10106Target = pt10105Value * (chkOpening / 100);
      const tt10106Target = tt10105Value * (chkOpening / 100);

      const { wellData } = useContext(WellContext);
              
      const nk1Data = wellData?.NK1 || {};




          

          const oilPercent =
            (nk1Data.percentages?.["C5+ liquid hydrocarbons (oil)"] || 0) +
            (nk1Data.percentages?.["Pentanes+ (C5+)"] || 0) +
            (nk1Data.percentages?.["Wax / paraffins"] || 0) +
            (nk1Data.percentages?.["Asphaltenes"] || 0);

          const gasPercent =
            (nk1Data.percentages?.["Dissolved light hydrocarbons C1–C4"] || 0) +
            (nk1Data.percentages?.["Methane (CH4)"] || 0) +
            (nk1Data.percentages?.["Ethane (C2H6)"] || 0) +
            (nk1Data.percentages?.["Propane (C3H8)"] || 0) +
            (nk1Data.percentages?.["Butanes (i-C4 / n-C4)"] || 0);

          const impPercent =
            (nk1Data.percentages?.["Carbon dioxide (CO2)"] || 0) +
            (nk1Data.percentages?.["Nitrogen (N2)"] || 0) +
            (nk1Data.percentages?.["Hydrogen sulfide (H2S)"] || 0) +
            (nk1Data.percentages?.["Formation water (H2O)"] || 0) +
            (nk1Data.percentages?.["Dissolved salts"] || 0) +
            (nk1Data.percentages?.["Sand"] || 0) +
            (nk1Data.percentages?.["Organic acids"] || 0) +
            (nk1Data.percentages?.["Trace metals"] || 0) +
            (nk1Data.percentages?.["Scale-forming ions"] || 0);


            const totalPercent = oilPercent + gasPercent + impPercent || 1;
            

            const totalRate = Number(nk1Data.productionRateInput) || 0;

            const oilBase = totalRate * (oilPercent / totalPercent);
            const gasBase = totalRate * (gasPercent / totalPercent);
            const impBase = totalRate * (impPercent / totalPercent);

            // 🔥 Apply CHK + SSSV logic
            const oilRate = isWellShut ? 0 : FIC_101051 + FIC_101052 + FIC_101053 + FIC_101054 + oilBase * chkFactor;
            const gasRate = isWellShut ? 0 : FIC_101051 + FIC_101052 + FIC_101053 + FIC_101054 + gasBase * chkFactor;
            const impRate = isWellShut ? 0 : FIC_101051 + FIC_101052 + FIC_101053 + FIC_101054 + impBase * chkFactor;


            
            const [fiqNK1, setFiqNK1] = useState(() => {
                return Number(localStorage.getItem("fiqNK1")) || 0;
              }); 

            useEffect(() => {
                const interval = setInterval(() => {

                  // 🔹 Get values
                  const totalRate = Number(nk1Data.productionRateInput) || 0;
                  const chkOpening = Number(valveData.CHK_101?.opening) || 0;
                  const chkFactor = chkOpening / 100;

                  // 🔹 Increment per second
                  const increment = totalRate * chkFactor;

                  // 🔹 Only accumulate if SSSV is OPEN
                  if (!valves.SSSV_10102) {
                    setFiqNK1(prev => prev + increment);
                  }

                }, 1000);

                return () => clearInterval(interval);

              }, [nk1Data.productionRateInput, valveData.CHK_101, valves.SSSV_10102]);

              const resetFIQ = () => {
                  setFiqNK1(0);
                };

                useEffect(() => {
            localStorage.setItem("fiqNK1", fiqNK1);
          }, [fiqNK1]);

                

                const totalFlow = oilRate + gasRate + impRate;

                const isXV10104Open = !valves.XV_10104; // assuming red = closed, lime = open
                const isXV10103Open = !valves.XV_10103;

                let fic10104 = 0;
                let fic10103 = 0;

                if (isXV10104Open && !isXV10103Open) {
                  // Only 10104 open
                  fic10104 = totalFlow;
                  fic10103 = 0;

                } else if (!isXV10104Open && isXV10103Open) {
                  // Only 10103 open
                  fic10104 = 0;
                  fic10103 = totalFlow;

                } else if (isXV10104Open && isXV10103Open) {
                  // Both open → split
                  fic10104 = totalFlow / 2;
                  fic10103 = totalFlow / 2;

                } else {
                  // Both closed
                  fic10104 = 0;
                  fic10103 = 0;
                }

                if (valves.SSSV_10102) {
                  fic10104 = 0;
                  fic10103 = 0;
                }

                  useEffect(() => {
                      localStorage.setItem("fic10103", fic10103);
                    }, [fic10103]);

                  useEffect(() => {
                      localStorage.setItem("fic10104", fic10104);
                    }, [fic10104]);

 




                const { updateWellSignals } = useContext(WellContext);
                useEffect(() => {
                  updateWellSignals("NK1", {
                    fic: fic10104,
                    pt: pt10106Target,
                    tt: tt10106Target,
                    fic2: fic10103,
                    pt2: pt10106Target,
                    oil: oilRate,
                    gas: gasRate,
                    water: impRate
                  });
                }, [fic10104], [pt10106Target], [oilRate], [gasRate], [impRate], [tt10106Target],
                [fic10103], [pt10106Target],
              );

                  


                


      const updateValveData = (tag, field, value) => {
        setValveData(prev => {
          const updated = {
            ...prev,
            [tag]: {
              ...prev[tag],
              [field]: value
            }
          };

          // 🔥 Save CHK opening globally
          if (tag === "CHK_101" && field === "opening") {
            localStorage.setItem("CHK_101_opening", value);
          }

          return updated;
        });
      };

      const [openPanels, setOpenPanels] = useState([]);

      // ✅ OPEN PANEL
        const openPanel = (tag) => {
          if (!openPanels.includes(tag)) {
            setOpenPanels(prev => [...prev, tag]);
          }
        };

        // ✅ CLOSE PANEL
        const closePanel = (tag) => {
          setOpenPanels(prev => prev.filter(v => v !== tag));
        };



        
                /* 🔥 ALARM ENGINE TAGS */
        
                const { evaluateTag } = useContext(AlarmContext);
        
                useEffect(() => {
                  evaluateTag("TT_10101", tt10101Value);
                  evaluateTag("FIC_10100", fic10100);
                  evaluateTag("FIC_10102", fic10102);
                  evaluateTag("PT_10107", pt10107);
                  evaluateTag("CHK_101", valveData.CHK_101.opening);


                }, [tt10101Value, fic10100, fic10102, pt10107, valveData.CHK_101.opening]);
                
                


  return (
    <div className="nk1-container">

      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "-16px",
        left: "280px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "4px 265px"
      }}>
        NK-1 WELLHEAD
      </h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "30px",
        left: "123px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10106
      </h2>

            {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "73px", left: "160px", color: "white", fontSize: "10px"}}>%</h2>

      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "89px",
        left: "123px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10105
      </h2>

            {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "131px", left: "160px", color: "white", fontSize: "10px"}}>%</h2>

       {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "205px", left: "190px", color: "white", fontSize: "10px"}}>%</h2>


        {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "458px", left: "190px", color: "white", fontSize: "10px"}}>%</h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "89px",
        left: "725px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10103
      </h2>

            {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "150px", left: "759px", color: "white", fontSize: "10px"}}>%</h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "433px",
        left: "905px",
        color: "black",
        fontSize: "10px"
      }}>
        FCV-10102
      </h2>

            {/* Percentage Opening */}
      <h2 style={{position: "absolute", top: "492px", left: "940px", color: "white", fontSize: "10px"}}>%</h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "445px",
        left: "1070px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10108
      </h2>


       {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "370px",
        left: "1092px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10103
      </h2>


       {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "270px",
        left: "1110px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10104
      </h2>


      {/* valve tags */}
      <h2 style={{
        position: "absolute",
        top: "337px",
        left: "285px",
        color: "black",
        fontSize: "10px"
      }}>
        XV-10109
      </h2>

{/* ================= TRANSMITTERS TAGS AND UNITS ================= */}

      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "293px",
        left: "255px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10110
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "293px",
        left: "330px",
        color: "black",
        fontSize: "10px"
      }}>
        FIC-10109
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "404px",
        left: "225px",
        color: "black",
        fontSize: "10px"
      }}>
        FIC-10101
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "438px",
        left: "300px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10109
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "174px",
        left: "420px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10105
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "214px",
        left: "590px",
        color: "black",
        fontSize: "10px"
      }}>
        CHK_101
      </h2>

            {/* SI unit */}
      <h2 style={{position: "absolute", top: "225px", left: "619px", color: "white", fontSize: "9px"}}>%</h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "92px",
        left: "539px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10108
      </h2>



 {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "92px",
        left: "629px",
        color: "black",
        fontSize: "10px"
      }}>
        FIC-10102
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "292px",
        left: "676px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10106
      </h2>



      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "282px",
        left: "760px",
        color: "black",
        fontSize: "10px",
        background:"blue",
      }}>
        MPFT-10100
      </h2>

           
      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "284px",
        left: "976px",
        color: "black",
        fontSize: "10px",
      }}>
        FIC-10104
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "375px",
        left: "976px",
        color: "black",
        fontSize: "10px",
      }}>
        FIC-10105
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "375px",
        left: "836px",
        color: "black",
        fontSize: "10px",
      }}>
        FIQ-10101
      </h2>


            {/* SI unit */}
      <h2 className="RESET_FIQ_10101" style={{position: "absolute", top: "382px", left: "898px", color: "white", fontSize: "10px"}}>RESET</h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "438px",
        left: "493px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-101013
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "438px",
        left: "573px",
        color: "black",
        fontSize: "10px"
      }}>
        TT-10101
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "438px",
        left: "705px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10107
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "438px",
        left: "810px",
        color: "black",
        fontSize: "10px"
      }}>
        FIC-10100
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "511px",
        left: "510px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10104
      </h2>



      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "511px",
        left: "330px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10102
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "618px",
        left: "330px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10101
      </h2>


      {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "618px",
        left: "509px",
        color: "black",
        fontSize: "10px"
      }}>
        PT-10103
      </h2>


       {/* Transmitter tags */}
      <h2 style={{
        position: "absolute",
        top: "618px",
        left: "584px",
        color: "black",
        fontSize: "10px"
      }}>
        TT-10101
      </h2>



      {/* ================= LINE AND PAGE CONNECTOR TAGS ================= */}

      <h2 style={{position: "absolute", top: "155px", left: "839px", color: "black", fontSize: "9px"}}>FROM CORROSION <br />INHIBITOR MANIFOLD</h2>

      <h2 style={{position: "absolute", top: "300px", left: "1239px", color: "white", fontSize: "9px"}}>TO TEST <br />HEADER</h2>

      <h2 style={{position: "absolute", top: "400px", left: "1219px", color: "white", fontSize: "9px"}}>TO PRODUCTION <br />HEADER</h2>

      <h2 style={{position: "absolute", top: "500px", left: "1209px", color: "black", fontSize: "9px"}}>FROM METHANOL <br />SUPPLY MANIFOLD</h2>

      <h2 style={{position: "absolute", top: "465px", left: "46px", color: "black", fontSize: "9px"}}>FROM GAS LIFT <br /> MANIFOLD</h2>

      <h2 style={{position: "absolute", top: "347px", left: "46px", color: "black", fontSize: "9px"}}>FROM ASPHALTHENE <br /> INHIBITOR MANIFOLD</h2>

      <h2 style={{position: "absolute", top: "269px", left: "42px", color: "black", fontSize: "9px"}}>KILL FLUID</h2>

      <h2 style={{position: "absolute", top: "205px", left: "42px", color: "black", fontSize: "9px"}}>FRESH WATER</h2>

      <h2 style={{position: "absolute", top: "137px", left: "42px", color: "black", fontSize: "9px"}}>COMPLETION <br />BRIME</h2>

      <h2 style={{position: "absolute", top: "80px", left: "42px", color: "black", fontSize: "9px"}}>NITROGEN</h2>



      {/* ================= VALVES + INDICATORS ================= */}

      {/* SSSV-10102 */}
      <Valve
        tag="SSSV_10102"
        x={500}
        y={250}
        isClosed={valves.SSSV_10102}
        toggle={toggleValve}
        className="SSSV-10102"
      />
      <Indicator
        x={950}
        y={125}
        isClosed={valves.SSSV_10102}
      />

      {/* XV-10104 */}
      <Valve
        tag="XV_10104"
        x={1115}
        y={290}
        isClosed={valves.XV_10104}
        toggle={toggleValve}
        className="XV-10104"
      />
      <Indicator
        x={950}
        y={170}
        isClosed={valves.XV_10104}
      />

      {/* XV-10103 */}
      <Valve
        className="XV-10103"
        tag="XV_10103"
        x={1100}
        y={393}
        isClosed={valves.XV_10103}
        toggle={toggleValve}
      />
      <Indicator
        x={950}
        y={215}
        isClosed={valves.XV_10103}
      />

      {/* DHSV-10101 */}
      <Valve
        tag="DHSV_10101"
        x={435}
        y={570}
        r={90}
        isClosed={valves.DHSV_10101}
        toggle={toggleValve}
        className="DHSV-10101"
      />
      <Indicator
        x={950}
        y={80}
        isClosed={valves.DHSV_10101}
      />

      {/* XV-10101 */}
      <Valve
        tag="XV_10101"
        x={530}
        y={160}
        r={90}
        isClosed={valves.XV_10101}
        toggle={toggleValve}
        className="XV-10101"
      />

      {/* XV-10105 */}
      <Valve
        tag="XV_10105"
        x={176}
        y={317}
        isClosed={valves.XV_10105}
        toggle={toggleValve}
        className="XV-10105"
      />

      {/* XV-10106 */}
      <Valve
        tag="XV_10106"
        x={120}
        y={238}
        isClosed={valves.XV_10106}
        toggle={toggleValve}
      />

      {/* XV-10107 */}
      <Valve
        tag="XV_10107"
        x={287}
        y={249}
        isClosed={valves.XV_10107}
        toggle={toggleValve}
        className="XV-10107"
      />

      {/* XV-10108 */}
      <Valve
        tag="XV_10108"
        x={1075}
        y={465}
        isClosed={valves.XV_10108}
        toggle={toggleValve}
        className="XV-10108"
      />


      {/* XV-10109 */}
      <Valve
        tag="XV_10109"
        x={290}
        y={355}
        isClosed={valves.XV_10109}
        toggle={toggleValve}
        className="XV-10109"
      />

      {/* GLV-1 */}
      <Valve
        tag="GLV_1"
        x={416}
        y={469}
        r={270}
        scale={0.7}
        isClosed={valves.GLV_1}
        toggle={toggleValve}
        className="GLV-1"
      />
      <Indicator
        x={1085}
        y={80}
        isClosed={valves.GLV_1}
      />


      {/* GLV-2 */}
      <Valve
        tag="GLV_2"
        x={416}
        y={522}
        r={270}
        scale={0.7}
        isClosed={valves.GLV_2}
        toggle={toggleValve}
        className="GLV-2"
      />
      <Indicator
        x={1085}
        y={126}
        isClosed={valves.GLV_2}
      />


      {/* GLV-3 */}
      <Valve
        tag="GLV_3"
        x={416}
        y={608}
        r={270}
        scale={0.7}
        isClosed={valves.GLV_3}
        toggle={toggleValve}
        className="GLV-3"
      />
      <Indicator
        x={1085}
        y={171}
        isClosed={valves.GLV_3}
      />


      {/* GLV-4 */}
      <Valve
        tag="GLV_4"
        x={438}
        y={635}
        r={90}
        scale={0.7}
        isClosed={valves.GLV_4}
        toggle={toggleValve}
        className="GLV-4"
      />
      <Indicator
        x={1085}
        y={215}
        isClosed={valves.GLV_4}
      />




      {/* ================= CONTROL VALVES ================= */}

        {/* FCV-10101 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10101"
          style={{ position: "absolute", left: 140, top: 423 }} onClick={() => openPanel("FCV_10101")}>
          
          <defs>
            <linearGradient id="metal_10101">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10101)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10101)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        {/* FCV-10102 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10102"
          style={{ position: "absolute", left: 890, top: 455 }} onClick={() => openPanel("FCV_10102")}>
          
          <defs>
            <linearGradient id="metal_10102">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10102)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10102)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>


        {/* FCV-10103 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-10103"
          style={{ position: "absolute", left: 709, top: 114 }} onClick={() => openPanel("FCV_10103")}>
          
          <defs>
            <linearGradient id="metal_10103">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10103)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10103)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>


        {/* FCV-10104 */}
        <svg width="80" height="40" viewBox="0 0 200 220" className="FCV-10104"
          style={{ position: "absolute", left: 140, top: 174 }} onClick={() => openPanel("FCV_10104")}>
          
          <defs>
            <linearGradient id="metal_10104">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10104)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10104)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>


        {/* FCV-10105 */}
        <svg width="80" height="40" viewBox="0 0 200 220" className="FCV-10105"
          style={{ position: "absolute", left: 108, top: 107 }} onClick={() => openPanel("FCV_10105")}>
          
          <defs>
            <linearGradient id="metal_10105">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10105)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10105)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>


        {/* FCV-10106 */}
        <svg width="80" height="40" viewBox="0 0 200 220" className="FCV-10106"
          style={{ position: "absolute", left: 108, top: 48 }} onClick={() => openPanel("FCV_10106")}>
          
          <defs>
            <linearGradient id="metal_10106">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_10106)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_10106)" stroke="#7f8c8d" strokeWidth="2" />
        </svg>

        <svg
            className="CHK-101"
            width="80"
            height="55"
            viewBox="0 0 220 260"
            style={{ position: "absolute", left: 549, top: 245 }}
            onClick={() => openPanel("CHK_101")}
          >

          {/* Top Thin White Accents */}
          <line x1="50" y1="60" x2="200" y2="100" stroke="blue" strokeWidth="12" />
          <line x1="320" y1="60" x2="200" y2="100" stroke="blue" strokeWidth="12" />
          <rect x="50" y="20" width="5" height="30" fill="blue" strokeWidth="12"/>
          
          
          {/* Red Geometric Body Parts */}
          <g fill="#cc0000" stroke="#777" strokeWidth="1">
            {/* Top cap */}
            <rect x="150" y="115" width="100" height="45" />
            
            {/* Upper section */}
            <rect x="110" y="160" width="180" height="55" />
            
            {/* Middle section with notch details */}
            <rect x="110" y="225" width="180" height="100" />
            <rect x="140" y="215" width="20" height="15" />
            <rect x="190" y="215" width="20" height="15" />
            <rect x="240" y="215" width="20" height="15" />
            
            {/* Tapered transition */}
            <polygon points="110,325 290,325 260,370 140,370" />
            
            {/* Lower neck */}
            <rect x="140" y="370" width="120" height="40" />
            
            {/* Base steps */}
            <rect x="130" y="420" width="140" height="25" />
            <rect x="130" y="450" width="140" height="20" />

          </g>
        </svg>




      {/* ✅ MULTIPLE FACEPLATES */}
      {openPanels.map((tag, index) => (
        <ControlValveControlPanel
          key={tag}
          tag={tag}
          data={valveData[tag]}
          update={updateValveData}
          close={() => closePanel(tag)}
          defaultPosition={{
            x: 300 + index * 40,
            y: 150 + index * 40
          }}
        />
      ))}




      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={valveData.CHK_101.opening}
        x={590}
        y={230}
      />

      <ValveOutput
        value={valveData.FCV_10101.opening}
        x={165}
        y={464}
      />

      <ValveOutput
        value={valveData.FCV_10102.opening}
        x={913}
        y={498}
      />

      <ValveOutput
        value={valveData.FCV_10103.opening}
        x={733}
        y={156}
      />

      <ValveOutput
        value={valveData.FCV_10104.opening}
        x={165}
        y={211}
      />

      <ValveOutput
        value={valveData.FCV_10105.opening}
        x={135}
        y={137}
      />

      <ValveOutput
        value={valveData.FCV_10106.opening}
        x={135}
        y={79}
      />


      <Transmitter
          tag="PT-10103"
          value={pt10103Value}
          x={498}
          y={633}
          unit="MPa"
          max={70}
          HH={60}
          H={55}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS AT THE PARKER ZONE OF NK-1"
        />

        <Transmitter
          tag="TT-10101"
          value={tt10101Value}
          x={577}
          y={633}
          unit="°C"
          max={250}
          HH={225}
          H={200}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS AT THE PARKER ZONE OF NK-1"
        />


        <Transmitter
          tag="PT-10104"
          value={pt10104Value}
          isClose={valves.DHSV_10101}
          toggle={toggleValve}
          x={499}
          y={525}
          unit="MPa"
          max={70}
          HH={60}
          H={55}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS AT THE PRODUCTION CASING ABOVE THE DOWNHOLE SAFETY VALVE OF NK-1"
        />

        <Transmitter
          tag="PT-101013"
          value={pt101013Value}
          isClose={valves.DHSV_10101}
          toggle={toggleValve}
          x={484}
          y={451.5}
          unit="MPa"
          max={25}
          HH={20}
          H={18}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS AT THE PRODUCTION CASING BELOW THE NK-1 WELLHEAD"
        />

        <Transmitter
          tag="TT-10102"
          value={tt10102Value}
          x={560}
          y={452}
          unit="°C"
          max={250}
          HH={225}
          H={200}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS AT THE PRODUCTION CASING BELOW THE NK-1 WELLHEAD"
        />

        <Transmitter
          tag="PT-10105"
          value={pt10105Value}
          isClose={valves.DHSV_10101}
          toggle={toggleValve}
          x={413}
          y={188}
          c="lime"
          unit="MPa"
          max={25}
          HH={18}
          H={16}
          L={0.3}
          LL={0.033}
          description="PRESSURE OF OIL AND GAS FLUID FROM NK-1 WELLHEAD TREE CAP"
        />

        <Transmitter
          tag="TT-10105"
          value={tt10105Value}
          x={409}
          y={199}
          unit="°C"
          max={250}
          HH={225}
          H={200}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS FLUID FROM NK-1 WELLHEAD TREE CAP"
        />

        <Transmitter
          tag="PT-10106"
          value={pt10106Target}
          controllingValveOpen={pt10105Value}
          toggle={toggleValve}
          x={668}
          y={308}
          unit="MPa"
          min={0}
          max={15}
          HH={13}
          H={12}
          L={3}
          LL={1}
          c="lime"
          description="Wellhead Production Pressure for Choke Management on NK-1 WELLHEAD"
        />

        <Transmitter
          tag="TT-10106"
          value={tt10106Target}
          controllingValveOpen={tt10105Value}
          toggle={toggleValve}
          x={665}
          y={319}
          unit="°C"
          max={150}
          HH={145}
          H={140}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS FLUID FROM NK-1 WELLHEAD TO TEST HEADER OR PRODUCTION HEADER"      
           />

          <Transmitter
          tag="FIQ-10101"
          value={fiqNK1.toFixed(2)}
          toggle={toggleValve}
          x={830}
          y={390}
          unit="BOE"
          max={50000}
          HH={38000}
          H={25000}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE TOTALIZER OF OIL AND GAS FROM NK-1 WELLHEAD AFTER THE CHOKE IN BARREL OF OIL EQUIVALENT"
        />
        
        <Transmitter
          tag="OIL_RATE"
          value={oilRate}
          x={755}
          y={299}
          unit="BPM"
          min={0}
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="Oil production rate from separator from NK-1 WELLHEAD."
        />

        <Transmitter
          tag="GAS_RATE"
          value={gasRate}
          x={755}
          y={309}
          unit="SCF/S"
          min={0}
          max={100}
          HH={96}
          H={90}
          L={10}
          LL={5}
          c="lime"
          description="Gas production rate from separator from NK-1 WELLHEAD."
        />

        <Transmitter
          tag="IMP_RATE"
          value={impRate}
          x={755}
          y={319}
          unit="LPM"
          min={0}
          max={25}
          HH={20}
          H={19}
          L={5}
          LL={2}
          c="lime"
          description="Impurity rate (water + solids) from NK-1 WELLHEAD."
        />

        <button
          onClick={resetFIQ}
          style={{
            position: "absolute",
            left: 895,
            top: 386
          }}
        >
          RESET
        </button>


        <Transmitter
          tag="FIC-10104"
          value={[fic10104]}
          x={966}
          y={298}
          unit="BOE/M"
          max={170}
          HH={165}
          H={150}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF PRODUCED FLUID FROM NK-1 WELLHEAD TO TEST MANIFOLD"
        />

        <Transmitter
          tag="FIC-10103"
          value={[fic10103]}
          x={964}
          y={390}
          unit="BOE/M"
          max={170}
          HH={165}
          H={150}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF PRODUCED FLUID FROM NK-1 WELLHEAD TO PRODUCTION MANIFOLD-1"
        />

        <Transmitter
          tag="PT-10107"
          value={pt10107}
          isClose={valves.XV_10108}
          toggle={toggleValve}
          x={700}
          y={451.5}
          unit="MPa"
          max={15}
          HH={14}
          H={10}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF METHANOL FROM METHANOL SUPPLY MANIFOLD"
        />

        <Transmitter
          tag="FIC-10100"
          value={fic10100}
          isClose={valves.XV_10108}
          toggle={toggleValve}
          x={805}
          y={451.5}
          unit="LPM"
          max={20}
          HH={18}
          H={15}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF METHANOL FROM METHANOL SUPPLY MANIFOLD."
        />

        <Transmitter
          tag="PT-10108"
          value={pt10108}
          isClose={valves.XV_10103}
          toggle={toggleValve}
          x={530}
          y={106}
          unit="MPa"
          max={15}
          HH={14}
          H={10}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF CORROSION INHIBITOR (WATER-BASED) FROM CORROSION INHIBITOR  MANIFOLD."
        />

        <Transmitter
          tag="FIC-10102"
          value={fic10102}
          isClose={valves.XV_10103}
          toggle={toggleValve}
          x={623}
          y={106}
          unit="LPM"
          max={20}
          HH={18}
          H={15}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF CORROSION INHIBITOR (WATER-BASED) FROM CORROSION INHIBITOR  MANIFOLD."
        />

        <Transmitter
          tag="PT-10109"
          value={pt10109}
          isClose={valves.XV_10109}
          toggle={toggleValve}
          x={293}
          y={452}
          unit="MPa"
          max={35}
          HH={24}
          H={20}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF GAS INJECTION FROM GAS LIFT  MANIFOLD."
        />

        <Transmitter
          tag="FIC-10101"
          value={fic10101}
          isClose={valves.XV_10109}
          toggle={toggleValve}
          x={215}
          y={418}
          unit="SCF/S"
          max={70}
          HH={68}
          H={65}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF GAS INJECTION FROM GAS LIFT  MANIFOLD."
        />

        <Transmitter
          tag="PT-10101"
          value={pt10101}
          toggle={toggleValve}
          x={245}
          y={309}
          unit="MPa"
          max={15}
          HH={14}
          H={10}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF ASPHALTENE INHIBITOR FROM ASPHALTENE INHIBITOR MANIFOLD."
        />

        <Transmitter
          tag="FIC-10109"
          value={fic10109}
          toggle={toggleValve}
          x={318}
          y={309}
          unit="SCF/S"
          max={20}
          HH={18}
          H={15}
          L={1.9}
          LL={1}
          c="lime"
          description="FLOWRATE OF ASPHALTENE INHIBITOR FROM ASPHALTENE INHIBITOR MANIFOLD."
        />

    </div>
  );
}




export default NK1Wellhead;